import { AfterViewInit, DOCUMENT, Directive, ElementRef, EventEmitter, Inject, OnDestroy, Output } from '@angular/core';
import { Subscription, fromEvent } from 'rxjs';
import { filter } from 'rxjs/operators';

@Directive({
  selector: '[lOutsideClick]',
  standalone: true
})
export class OutsideClick implements AfterViewInit, OnDestroy {
  constructor(
    private readonly element: ElementRef,
    @Inject(DOCUMENT) private readonly document: Document
  ) {}

  @Output()
  public outsideClick = new EventEmitter<void>();

  public documentClickSubscription?: Subscription;

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.documentClickSubscription = fromEvent(this.document, 'click')
        .pipe(filter(event => !this.isInside(event.target as HTMLElement)))
        .subscribe(() => this.outsideClick.emit());
    }, 0);
  }

  public ngOnDestroy(): void {
    if (this.documentClickSubscription) this.documentClickSubscription.unsubscribe();
  }

  private isInside(elementToCheck: HTMLElement): boolean {
    const nativeElement = this.element.nativeElement;
    return elementToCheck === nativeElement || nativeElement.contains(elementToCheck);
  }
}
